import { Args, AxiosConfig } from './BaseService';
import { CrudService } from './CrudService';
import { resources } from '../resources';
import { AxiosPromise } from 'axios';
import { CompanyDto } from '../models/company/CompanyDto';
import { CreateCompanyRequest } from '../models/company/CreateCompanyRequest';
import { CompanyQueryParams } from '../params/CompanyQueryParams';
import { SupplierEmployeeDto } from '../models/suppliers/SupplierEmployeeDto';
import { CompanyPageDto } from '../models/settings/CompanyPageDto';
import { BatchPageUpdate } from '../models/settings/BatchPageUpdate';
import { CompanyPageQueryParams } from '../params/CompanyPageQueryParams';

export class CompanyService extends CrudService<CompanyDto, CompanyQueryParams, CreateCompanyRequest> {
  constructor() {
    super({
      query: resources.queryCompanies,
      get: resources.getCompany,
      create: resources.createCompany,
      update: resources.updateCompany,
      idKey: 'companyId',
    });
  }

  public requestCompanyDeletion(companyId: string, args?: Args, options: AxiosConfig = {}): AxiosPromise<void> {
    return this.delete<void>(resources.requestCompanyDeletion, { companyId, ...args }, options);
  }

  public cancelCompanyDeletion(companyId: string, args?: Args, options: AxiosConfig = {}): AxiosPromise<void> {
    return this.delete<void>(resources.cancelCompanyDeletion, { companyId, ...args }, options);
  }

  public findSupplierEmployeeInCompany(args?: Args): AxiosPromise<SupplierEmployeeDto> {
    return this.get<SupplierEmployeeDto>(resources.findSupplierEmployeeInCompany, args);
  }

  public queryCompanyPages(params?: CompanyPageQueryParams, options: AxiosConfig = {}): AxiosPromise<CompanyPageDto[]> {
    return this.get<CompanyPageDto[]>(resources.queryCompanyPages, params, options);
  }

  public updateCompanyPage(data: BatchPageUpdate, args?: Args, options: AxiosConfig = {}): AxiosPromise<void> {
    return this.put<void>(resources.updateCompanyPage, data, args, options);
  }
}
